<div class="flex items-center" *transloco="let t">
	<vex-breadcrumb>
		<a [routerLink]="['/dashboard']">
			<mat-icon svgIcon="mat:home" class="icon-sm"></mat-icon>
		</a>
	</vex-breadcrumb>
	<ng-container>
		@for (crumb of crumbs(); track crumb.translationKey) {
			<div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2"></div>
			<vex-breadcrumb>
				@if (layoutService.isMobile() || layoutService.isTablet()) {
					<a [routerLink]="[get_route_for_crumb(crumb)]">
						<mat-icon [svgIcon]="crumb.icon" class="icon-sm"></mat-icon>
					</a>
				} @else {
					<a [routerLink]="[get_route_for_crumb(crumb)]">
						{{ t(crumb.translationKey) }}
						@if (crumb.additionalInfo) {
							({{ crumb.additionalInfo }})
						}
					</a>
				}
			</vex-breadcrumb>
		}
	</ng-container>
</div>
